import {
  BOOLEAN_OPTIONS,
  booleanOptionLabels,
} from "@/constant/GeneralOptions/boolean";
import { STATUS } from "@/constant/statusConstants";
import * as Yup from "yup";
import { DEFAULT_LANGUAGE } from "@/constant/Languages/language";

const booleanOptionLabelsMap = booleanOptionLabels();
const boLabelYes = booleanOptionLabelsMap[BOOLEAN_OPTIONS.YES];
const boLabelNo = booleanOptionLabelsMap[BOOLEAN_OPTIONS.NO];

const PlayerSchema = (targetLang = DEFAULT_LANGUAGE) =>
  Yup.object().shape({
    code: Yup.string()
      .label("ID")
      .max(50)
      .when([], {
        is: () => targetLang === DEFAULT_LANGUAGE,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      }),
    name: Yup.string()
      .label("Player Name")
      .max(255)
      .when([], {
        is: () => targetLang === DEFAULT_LANGUAGE,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      }),
    sport_id: Yup.string()
      .label("Sport")
      .when([], {
        is: () => targetLang === DEFAULT_LANGUAGE,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      }),
    player_type_id: Yup.number()
      .label("Player Type")
      .when([], {
        is: () => targetLang === DEFAULT_LANGUAGE,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      }),
    birth_city: Yup.string()
      .label("Birth City")
      .when([], {
        is: () => targetLang === DEFAULT_LANGUAGE,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      }),
    birth_country_id: Yup.number()
      .label("Birth Country")
      .when([], {
        is: () => targetLang === DEFAULT_LANGUAGE,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      }),
    birth_date: Yup.date()
      .label("Birth Date")
      .when([], {
        is: () => targetLang === DEFAULT_LANGUAGE,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      }),
    height: Yup.number()
      .label("Height")
      .when([], {
        is: () => targetLang === DEFAULT_LANGUAGE,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      }),
    nationality_id_1: Yup.number()
      .label("Nationality 1")
      .when([], {
        is: () => targetLang === DEFAULT_LANGUAGE,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      }),
    nationality_id_2: Yup.number().label("Nationality 2").nullable(),
    nationality_id_3: Yup.number().label("Nationality 3").nullable(),
    is_notable_player: Yup.boolean()
      .label("Is Notable Player")
      .when([], {
        is: () => targetLang === DEFAULT_LANGUAGE,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      })
      .oneOf(
        Object.values(BOOLEAN_OPTIONS),
        `Is Notable Player must be one of the following values: ${Object.values(
          booleanOptionLabels
        ).join(", ")}`
      ),
    is_legend_player: Yup.boolean()
      .label("Is Legend Player")
      .when([], {
        is: () => targetLang === DEFAULT_LANGUAGE,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      })
      .oneOf(
        Object.values(BOOLEAN_OPTIONS),
        `Is Legend Player must be one of the following values: ${Object.values(
          booleanOptionLabels
        ).join(", ")}`
      ),
    show_in_profile: Yup.boolean()
      .label("Show Profile")
      .when([], {
        is: () => targetLang === DEFAULT_LANGUAGE,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      })
      .oneOf(
        Object.values(BOOLEAN_OPTIONS),
        `Show Profile must be one of the following values: ${Object.values(
          booleanOptionLabels
        ).join(", ")}`
      ),
    tags: Yup.array().label("Player Name (Tags)").nullable(),
    tagline: Yup.string().label("Sub Title").required().max(120),
    content: Yup.string().label("Content").required(),
    auto_translate: Yup.bool()
      .label("Translate All")
      .nullable()
      .oneOf(
        Object.values(BOOLEAN_OPTIONS),
        `Translate All must be one of the following values: ${boLabelYes}, ${boLabelNo}`
      ),
    status: Yup.string()
      .label("Status")
      .when([], {
        is: () => targetLang === DEFAULT_LANGUAGE,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.nullable(),
      })
      .oneOf(Object.values(STATUS)),
  });

export default PlayerSchema;
